module.exports = __webpack_public_path__ + "img/B6.cbe93461.png";